import {useHistory, useParams} from "react-router-dom";
import classes from "./Report.module.css";
import {
    REPORT_ACTIVITY_TABLE_DESC, REPORT_ACTIVITY_TABLE_TITLE,
    REPORT_ACTIVITY_TITLE,
    REPORT_ACTIVITY_TITLE_DESC,
    REPORT_BROWSER_TYPES,
    REPORT_FINISHED_METRIC_TITLE, REPORT_INCOMPLETE_METRIC_TITLE,
    REPORT_PARTICIPANT_METRIC_TITLE,
    REPORT_PLATFORM_TYPES,
    TOTAL_QUESTIONS_TEXT
} from "../../utils/constants";
import {ReactComponent as TOTAL_QUE_ICON}  from "./images/MetricIconTotalQue-activity.svg";
import {ReactComponent as PARTICIPANT_ICON}  from "./images/MetricIconParticipant-activity.svg";
import {ReactComponent as FINISHED_ICON}  from "./images/MetricIconFinished.svg";
import {ReactComponent as INCOMPLETE_ICON}  from "./images/MetricIconIncomplete.svg";
import {ReactComponent as PLATFORM_ICON}  from "./images/MetricPlatform.svg";
import {ReactComponent as BROWSER_ICON}  from "./images/MetricBrowser.svg";
import {ReactComponent as TABLE_ICON}  from "./images/ChartIcon.svg";
import {ReactComponent as GRADE_BOOK_ICON}  from "./images/GradeBookIcon.svg";

import {
    getFullMonthYear,
    getMetricBGColorByCount,
    getMetricColorByCount,
    getTrendByCount, getYearMonthStr,
    isCountIncreased
} from "./ReportHelper";
import React, {useEffect, useRef, useState} from "react";
import {PollApiCalls} from "../../apis/PollApiCalls";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import TabQuestions from "./TabQuestions";
import YuJaButton from "../../components/standardization/YuJaButton";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import {useReportMetricCardDivider} from "../../hooks/useReportMetricCardDivider";
import {removePrefix} from "../../utils/helpers";
import {Button} from "@base-ui/react/button";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import styles from "../ManagePollsPage/ManagePolls.module.css";

export default function ReportActivityPage(props) {
    const { pollKey, pollCode } = useParams();

    const {getPollDataFromKey} = PollApiCalls();
    const {getActivityWiseReport} = ReportApiCalls();
    let history = useHistory();
    const [, getSession] = useLocalStorageNew("session", {});

    const [poll, setPoll] = useState({});
    const [curDate, ] = useState(() =>{
        let currentDate = new Date();
        currentDate.setDate(1);
        return getYearMonthStr(currentDate);
    });
    const [overviewCount, setOverviewCount] = useState({});
    const [lastMonthCount, setLastMonthCount] = useState({});
    const [browserCount, setBrowserCount] = useState([]);
    const [platformCount, setPlatformCount] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [browserNoData, ] = useState(() => {
        let data = [];
        for (const key in REPORT_BROWSER_TYPES) {
            data.push({name: REPORT_PLATFORM_TYPES[key], value: 1, fill: "#E1E1E1"});
        }
        return data;
    });
    const [platformNoData, ] = useState(() => {
        let data = [];
        for (const key in REPORT_PLATFORM_TYPES) {
            data.push({name: REPORT_PLATFORM_TYPES[key], value: 1, fill: "#E1E1E1"});
        }
        return data;
    });

    const [dataLoading, setDataLoading] = useState(false);
    const [pollLoading, setPollLoading] = useState(false);
    const [popularPlatform, setPopularPlatform] = useState("");
    const [popularBrowser, setPopularBrowser] = useState("");

    const containerRef = useRef();
    let {maxCardsPerRow} = useReportMetricCardDivider(containerRef);
    const [isActivityOwner, setIsActivityOwner] = useState(false);


    const BROWSER_DIAGRAM_COLORS = ["#4F75CB", "#E2726E", "#6DA186", "#81CCC9", "#EBBE79", "#E992D8"];
    const PLATFORM_DIAGRAM_COLORS = ["#E992D8", "#928FDC", "#E19278", "#EBBE79"];

    const DATE_FORMAT_OPTION = {
        weekday: 'long',  // Full name of the day
        year: 'numeric',  // Full year
        month: 'long',    // Full name of the month
        day: 'numeric',   // Day of the month
        hour: '2-digit',  // 2-digit hour
        minute: '2-digit', // 2-digit minute
        second: '2-digit', // 2-digit second
        hour12: true       // 12-hour format with AM/PM
    }


    useEffect(() => {
        props.setPageIdentifier(REPORT_ACTIVITY_TITLE);
    }, []);

    useEffect(() => {
        setPollLoading(true);
        getPollDataFromKey(pollKey).then(res => {
            let poll = !!res ? res : {};
            let {ownerId=""} = poll;
            setPoll(poll);
            let {userId=""} = getSession();
            setIsActivityOwner(removePrefix(ownerId) === userId);
        }).finally(() => {
            setPollLoading(false);
        });

        setDataLoading(true);
        getActivityWiseReport(pollKey, curDate).then(result => {
            const {
                questionCount=0, participantCount=0, finishedCount=0, incompleteCount=0,
                chromeCount=0, firefoxCount=0, edgeCount=0, safariCount=0, mobileAppCount=0, otherBrowserCount=0,
                appleCount=0, androidCount=0, windowsCount=0, otherPlatformCount=0,
                lastMonthCount={},
                questions=[],
            } = result;

            setOverviewCount({questionCount, participantCount, finishedCount, incompleteCount});
            setLastMonthCount(lastMonthCount);
            setQuestions(questions);

            let browserCount = [];
            browserCount.push({name: REPORT_BROWSER_TYPES.CHROME.name, value: chromeCount});
            browserCount.push({name: REPORT_BROWSER_TYPES.FIREFOX.name, value: firefoxCount});
            browserCount.push({name: REPORT_BROWSER_TYPES.EDGE.name, value: edgeCount});
            browserCount.push({name: REPORT_BROWSER_TYPES.SAFARI.name, value: safariCount});
            browserCount.push({name: REPORT_BROWSER_TYPES.MOBILE_APP.name, value: mobileAppCount});
            browserCount.push({name: REPORT_BROWSER_TYPES.OTHERS.name, value: otherBrowserCount});
            browserCount = browserCount.sort((a, b) => b.value - a.value);
            let idx = 0;
            for (const item of browserCount) {
                item.fill = BROWSER_DIAGRAM_COLORS[idx % 4];
                idx++;
            }
            setBrowserCount(browserCount);
            setPopularBrowser(!!browserCount[0].value ? browserCount[0].name : "");

            let platformCount = [];
            platformCount.push({name: REPORT_PLATFORM_TYPES.APPLE.name, value: appleCount});
            platformCount.push({name: REPORT_PLATFORM_TYPES.ANDROID.name, value: androidCount});
            platformCount.push({name: REPORT_PLATFORM_TYPES.WINDOWS.name, value: windowsCount});
            platformCount.push({name: REPORT_PLATFORM_TYPES.OTHERS.name, value: otherPlatformCount});
            platformCount = platformCount.sort((a, b) => b.value - a.value);
            idx = 0;
            for (const item of platformCount) {
                item.fill = PLATFORM_DIAGRAM_COLORS[idx % 4];
                idx++;
            }
            setPlatformCount(platformCount);
            setPopularPlatform(!!platformCount[0].value ? platformCount[0].name : "");
        }).finally(() => {
            setDataLoading(false);
        });

    }, [pollKey]);

    const viewGradeBook = () => {
        history.push({
            pathname: "/gradeBook",
            state: {...poll, pollKey: pollKey, uniqueCode: pollCode}
        });
    }

    const viewReleasePoll = () => {
        if (!isActivityOwner) {
            return;
        }
        history.push({
            pathname: `/poll/share/${pollKey}/${pollCode}`,
        });
    }

    const renderMostUsedBrowserIcon = () => {
        if (!popularBrowser) {
            return (
                <div className={classes.metric} style={{fontSize: 20}}>
                    N/A
                </div>
            );
        }

        let {icon, description} = Object.values(REPORT_BROWSER_TYPES).find(i => i.name === popularBrowser);
        let Icon = icon;
        return (
            <YuJaTooltip text={description} disableTab={true}>
                <Icon/>
            </YuJaTooltip>
        );
    }

    const renderMostUsedPlatformIcon = () => {
        if (!popularPlatform) {
            return (
                <div className={classes.metric} style={{fontSize: 20}}>
                    N/A
                </div>
            );
        }

        let {icon, description} = Object.values(REPORT_PLATFORM_TYPES).find(i => i.name === popularPlatform);
        let Icon = icon;
        return (
            <YuJaTooltip text={description} disableTab={true}>
                <Icon/>
            </YuJaTooltip>
        );
    }

    return (
        <div className={classes.parentContainer} ref={containerRef}>
            {!pollLoading &&
                <div className={classes.titleCard} >
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <span className={classes.title}>{REPORT_ACTIVITY_TITLE}</span>
                        <span style={{height: 15}}/>
                        {isActivityOwner
                            ? (
                                <Button
                                    onClick={viewReleasePoll}
                                    className={classes.clickableCourseInfoLabel}
                                    style={{textAlign: "start"}}
                                >{poll.pollTitle}</Button>
                            )
                            :(
                                <div className={classes.courseInfoLabel} style={{color: "#000", textAlign: "start"}}>
                                    {poll.pollTitle}
                                </div>
                            )
                        }

                        <span style={{height: 15}}/>
                        <span className={classes.description}>{REPORT_ACTIVITY_TITLE_DESC}</span>
                    </div>
                    <div style={{flex: 1}}/>
                    <div style={{display: "flex", flexDirection: "column"}}>
                    <span className={classes.description}>
                        <span className={classes.regularLabel} style={{marginRight: 5}}>Update on:</span>
                        {new Date(poll.updatedTimeSK).toLocaleString('en-US', DATE_FORMAT_OPTION)}.
                    </span>
                        <span style={{height: 20}}/>
                        {!!isActivityOwner &&
                            <YuJaButton style={{alignSelf: "flex-end"}} onClick={viewGradeBook}>
                                <GRADE_BOOK_ICON/> View Gradebook
                            </YuJaButton>
                        }
                    </div>
                </div>
            }

            {!!pollLoading &&
                <div className={classes.titleCard}>
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <span className={classes.title}>{REPORT_ACTIVITY_TITLE}</span>
                        <span style={{height: 15}}/>
                        <Skeleton
                            borderRadius={10} height={16} inline={true} width={"100%"}
                            className={classes.cardNumberSkeleton}
                            containerClassName={classes.cardNumberSkeletonWrapper}
                        />
                        <span style={{height: 15}}/>
                        <span className={classes.description}>{REPORT_ACTIVITY_TITLE_DESC}</span>
                    </div>
                    <div style={{flex: 1}}/>
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <Skeleton borderRadius={10} height={16} inline={true} width={300}
                                  className={classes.cardNumberSkeleton}
                                  containerClassName={classes.cardNumberSkeletonWrapper}
                        />
                    </div>
                </div>
            }


            {/*part1: metric card*/}
            {!dataLoading &&
                <div
                    className={classes.metricCardsContainer}
                    style={{
                        gridTemplateColumns: maxCardsPerRow === 6 ? '4fr 4fr 4fr 4fr 5fr 5fr' : `repeat(${maxCardsPerRow}, 1fr)`
                    }}
                >
                    {/*TOTAL QUESTION*/}
                    <div className={classes.metricCard} >
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <div className={classes.regularLabel}>{TOTAL_QUESTIONS_TEXT}</div>
                            <div style={{height: 10}}/>
                            <div className={classes.row} style={{gap: 8}}>
                                <div className={classes.metric}>
                                    {!!overviewCount.questionCount ? overviewCount.questionCount.toLocaleString() : 0}
                                </div>
                                <div
                                    className={classes.growBadge}
                                    style={{
                                        background: getMetricBGColorByCount(lastMonthCount.questionCount),
                                        color: getMetricColorByCount(lastMonthCount.questionCount)
                                    }}
                                >
                                    {isCountIncreased(lastMonthCount.questionCount) === false ? "" : "+"}
                                    {!!lastMonthCount.questionCount ? lastMonthCount.questionCount : 0}
                                    {getTrendByCount(lastMonthCount.questionCount)}
                                </div>
                            </div>
                            <div className={classes.month}>
                                {getFullMonthYear(curDate)}
                            </div>

                        </div>
                        <TOTAL_QUE_ICON style={{flexShrink: 0}}/>
                    </div>
                    {/*PARTICIPANT*/}
                    <div className={classes.metricCard} >
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <div className={classes.regularLabel}>{REPORT_PARTICIPANT_METRIC_TITLE}</div>
                            <div style={{height: 10}}/>
                            <div className={classes.row} style={{gap: 8}}>
                                <div className={classes.metric}>
                                    {!!overviewCount.participantCount ? overviewCount.participantCount.toLocaleString() : 0}
                                </div>
                                <div
                                    className={classes.growBadge}
                                    style={{
                                        background: getMetricBGColorByCount(lastMonthCount.participantCount),
                                        color: getMetricColorByCount(lastMonthCount.participantCount)
                                    }}
                                >
                                    {isCountIncreased(lastMonthCount.participantCount) === false ? "" : "+"}
                                    {!!lastMonthCount.participantCount ? lastMonthCount.participantCount : 0}
                                    {getTrendByCount(lastMonthCount.participantCount)}
                                </div>
                            </div>
                            <div className={classes.month}>
                                {getFullMonthYear(curDate)}
                            </div>
                        </div>
                        <PARTICIPANT_ICON style={{flexShrink: 0}}/>
                    </div>

                    {/*FINISHED*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <div className={classes.regularLabel}>{REPORT_FINISHED_METRIC_TITLE}</div>
                            <div style={{height: 10}}/>
                            <div className={classes.row} style={{gap: 8}}>
                                <div className={classes.metric}>
                                    {!!overviewCount.finishedCount ? overviewCount.finishedCount.toLocaleString() : 0}
                                </div>
                                <div
                                    className={classes.growBadge}
                                    style={{
                                        background: getMetricBGColorByCount(lastMonthCount.finishedCount),
                                        color: getMetricColorByCount(lastMonthCount.finishedCount)
                                    }}
                                >
                                    {isCountIncreased(lastMonthCount.finishedCount) === false ? "" : "+"}
                                    {!!lastMonthCount.finishedCount ? lastMonthCount.finishedCount : 0}
                                    {getTrendByCount(lastMonthCount.finishedCount)}
                                </div>
                            </div>
                            <div className={classes.month}>
                                {getFullMonthYear(curDate)}
                            </div>
                        </div>
                        <FINISHED_ICON style={{flexShrink: 0}}/>
                    </div>

                    {/*INCOMPLETE*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <div className={classes.regularLabel}>{REPORT_INCOMPLETE_METRIC_TITLE}</div>
                            <div style={{height: 10}}/>
                            <div className={classes.row} style={{gap: 8}}>
                                <div className={classes.metric}>
                                    {!!overviewCount.incompleteCount ? overviewCount.incompleteCount.toLocaleString() : 0}
                                </div>
                                <div
                                    className={classes.growBadge}
                                    style={{
                                        background: getMetricBGColorByCount(lastMonthCount.incompleteCount),
                                        color: getMetricColorByCount(lastMonthCount.incompleteCount)
                                    }}
                                >
                                    {isCountIncreased(lastMonthCount.incompleteCount) === false ? "" : "+"}
                                    {!!lastMonthCount.incompleteCount ? lastMonthCount.incompleteCount : 0}
                                    {getTrendByCount(lastMonthCount.incompleteCount)}
                                </div>
                            </div>
                            <div className={classes.month}>
                                {getFullMonthYear(curDate)}
                            </div>
                        </div>
                        <INCOMPLETE_ICON style={{flexShrink: 0}}/>
                    </div>

                    {/*PLATFORM*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <div className={classes.regularLabel}>{"Most Used Operating System"}</div>
                            <div style={{height: 15}}/>

                            {renderMostUsedPlatformIcon()}
                        </div>
                        <PLATFORM_ICON style={{flexShrink: 0}}/>
                    </div>

                    {/*BROWSER*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <div className={classes.regularLabel}>{"Most Used Web Browser"}</div>
                            <div style={{height: 15}}/>

                            {renderMostUsedBrowserIcon()}
                        </div>
                        <BROWSER_ICON style={{flexShrink: 0}}/>
                    </div>



                    {/*<ReportDoughnutChart title={REPORT_ACTIVITY_PIE_CHART_PLATFORM_LABEL} countData={platformCount} emptyCountData={platformNoData}/>*/}

                    {/*/!*BROWSER*!/*/}
                    {/*<ReportDoughnutChart title={REPORT_ACTIVITY_PIE_CHART_BROWSER_LABEL} countData={browserCount} emptyCountData={browserNoData}/>*/}
                </div>
            }



            {!!dataLoading &&
                <div
                    className={classes.metricCardsContainer}
                    style={{
                        gridTemplateColumns: maxCardsPerRow === 6 ? '4fr 4fr 4fr 4fr 5fr 5fr' : `repeat(${maxCardsPerRow}, 1fr)`
                    }}
                >
                    {/*TOTAL QUESTION*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <Skeleton borderRadius={4} height={23} inline={true}
                                      width={80}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                                      style={{flexShrink: 0}}
                            />
                            <div style={{height: 15}}/>
                            <Skeleton borderRadius={4} height={30} inline={true} width={60}
                                      className={classes.cardNumberSkeleton}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                            />
                        </div>

                        <Skeleton borderRadius={4} height={48} inline={true}
                                  width={48}
                                  containerClassName={styles.cardNumberSkeletonWrapper}
                                  style={{flexShrink: 0}}
                        />
                    </div>
                    {/*PARTICIPANT*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <Skeleton borderRadius={4} height={23} inline={true}
                                      width={100}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                                      style={{flexShrink: 0}}
                            />
                            <div style={{height: 15}}/>
                            <Skeleton borderRadius={4} height={30} inline={true} width={60}
                                      className={classes.cardNumberSkeleton}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                            />
                        </div>

                        <Skeleton borderRadius={4} height={48} inline={true}
                                  width={48}
                                  containerClassName={styles.cardNumberSkeletonWrapper}
                                  style={{flexShrink: 0}}
                        />
                    </div>

                    {/*FINISHED*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <Skeleton borderRadius={4} height={23} inline={true}
                                      width={100}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                                      style={{flexShrink: 0}}
                            />
                            <div style={{height: 15}}/>
                            <Skeleton borderRadius={4} height={30} inline={true} width={60}
                                      className={classes.cardNumberSkeleton}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                            />
                        </div>
                        <Skeleton borderRadius={4} height={48} inline={true}
                                  width={48}
                                  containerClassName={styles.cardNumberSkeletonWrapper}
                                  style={{flexShrink: 0}}
                        />
                    </div>
                    {/*INCOMPLETE*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <Skeleton borderRadius={4} height={23} inline={true}
                                      width={120}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                                      style={{flexShrink: 0}}
                            />
                            <div style={{height: 15}}/>
                            <Skeleton borderRadius={4} height={30} inline={true} width={60}
                                      className={classes.cardNumberSkeleton}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                            />
                        </div>
                        <Skeleton borderRadius={4} height={48} inline={true}
                                  width={48}
                                  containerClassName={styles.cardNumberSkeletonWrapper}
                                  style={{flexShrink: 0}}
                        />
                    </div>

                    {/*PLATFORM*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <Skeleton borderRadius={4} height={23} inline={true}
                                      width={150}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                                      style={{flexShrink: 0}}
                            />
                            <div style={{height: 15}}/>
                            <Skeleton borderRadius={4} height={40} inline={true} width={40}
                                      className={classes.cardNumberSkeleton}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                            />
                        </div>
                        <Skeleton borderRadius={4} height={48} inline={true}
                                  width={48}
                                  containerClassName={styles.cardNumberSkeletonWrapper}
                                  style={{flexShrink: 0}}
                        />
                    </div>


                    {/*BROWSER*/}
                    <div className={classes.metricCard}>
                        <div className={classes.column} style={{ flex: 1, minWidth: 50, height: "100%"}}>
                            <Skeleton borderRadius={4} height={23} inline={true}
                                      width={140}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                                      style={{flexShrink: 0}}
                            />
                            <div style={{height: 15}}/>
                            <Skeleton borderRadius={4} height={40} inline={true} width={40}
                                      className={classes.cardNumberSkeleton}
                                      containerClassName={classes.cardNumberSkeletonWrapper}
                            />
                        </div>
                        <Skeleton borderRadius={4} height={48} inline={true}
                                  width={48}
                                  containerClassName={styles.cardNumberSkeletonWrapper}
                                  style={{flexShrink: 0}}
                        />
                    </div>
                </div>
            }



            {/* part2: table*/}
            {!dataLoading &&
                <div className={classes.tableCardContainer} style={{height: "fit-content"}}>
                    <div className={classes.cardContainerHead}>
                        <TABLE_ICON/>
                        {REPORT_ACTIVITY_TABLE_TITLE}
                    </div>

                    <div className={classes.cardContainerBody}>
                        <div className={classes.description}>{REPORT_ACTIVITY_TABLE_DESC}</div>
                        <TabQuestions data={questions} setData={setQuestions}/>
                    </div>
                </div>
            }

            {!!dataLoading &&
                <div className={classes.tableCardContainer} style={{height: 530}}>

                    <div className={classes.cardContainerHead}>
                        <TABLE_ICON/>
                        {REPORT_ACTIVITY_TABLE_TITLE}
                    </div>

                    <div className={classes.cardContainerBody}>
                        <Skeleton borderRadius={10} height={30} inline={true} width={350}
                                  className={classes.cardNumberSkeleton}
                                  containerClassName={classes.cardNumberSkeletonWrapper}
                        />
                        <Skeleton borderRadius={10} height={30} inline={true} width={300}
                                  className={classes.cardNumberSkeleton}
                                  containerClassName={classes.cardNumberSkeletonWrapper}
                        />
                        <Skeleton borderRadius={10} height={30} inline={true} width={"100%"}
                                  className={classes.cardNumberSkeleton}
                                  containerClassName={classes.cardNumberSkeletonWrapper}
                        />

                        <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                            <div style={{display: "grid", gridTemplateColumns: "15% 25% 15% 15% 15% 15%"}}>
                                <Skeleton borderRadius={10} height={30} width={"30%"} style={{position: "relative"}}/>
                                <Skeleton borderRadius={10} height={30} width={"80%"} style={{position: "relative"}}/>
                                <Skeleton borderRadius={10} height={30} width={"30%"} style={{position: "relative"}}/>
                                <Skeleton borderRadius={10} height={30} width={"30%"} style={{position: "relative"}}/>
                                <Skeleton borderRadius={10} height={30} width={"30%"} style={{position: "relative"}}/>
                                <Skeleton borderRadius={10} height={30} width={"30%"} style={{position: "relative"}}/>
                            </div>
                            <div style={{display: "grid", gridTemplateColumns: "15% 25% 15% 15% 15% 15%"}}>
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}/>
                                <Skeleton borderRadius={10} height={25} width={`${70 + Math.random() * 10}%`}/>
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}/>
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}/>
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}/>
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}/>

                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}
                                          style={{marginTop: 15}}/>
                                <Skeleton borderRadius={10} height={25} width={`${70 + Math.random() * 10}%`}
                                          style={{marginTop: 15}}/>
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}
                                          style={{marginTop: 15}}/>
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}
                                          style={{marginTop: 15}}/>
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}
                                          style={{marginTop: 15}}/>
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}
                                          style={{marginTop: 15}}/>

                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}
                                          style={{marginTop: 15}}/>
                                <Skeleton borderRadius={10} height={25} width={`${70 + Math.random() * 10}%`}
                                          style={{marginTop: 15}}/>
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}
                                          style={{marginTop: 15}}/>
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}
                                          style={{marginTop: 15}}/>
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}
                                          style={{marginTop: 15}}/>
                                <Skeleton borderRadius={10} height={25} width={`${20 + Math.random() * 10}%`}
                                          style={{marginTop: 15}}/>
                            </div>
                        </SkeletonTheme>
                    </div>
                </div>
            }
        </div>
    );
}